import script from "./payment-vouchers.vue?vue&type=script&setup=true&lang=js"
export * from "./payment-vouchers.vue?vue&type=script&setup=true&lang=js"

import "./payment-vouchers.vue?vue&type=style&index=0&id=59394751&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59394751"]])

export default __exports__